import { Message } from 'element-ui';
import { MessageBox } from 'element-ui';
import { Notification } from 'element-ui';

import itemApi from '@/services/API/items'
import invoiceApi from '@/services/API/invoice'
import moment from 'moment';

import Promise from 'bluebird'


/**
 * Calcule la due date basé sur le term et sur la date de facturation
 * @param  {[type]} customerInvoiceTerm [description]
 * @param  {[type]} invoiceDate         [description]
 * @return {[type]}                     [description]
 */
function calculateDueDate(customerInvoiceTerm, invoiceDate){
  let dueDate = null;
  if(customerInvoiceTerm.value=="END_MONTH"){
    dueDate = moment(invoiceDate).endOf('month');
  }else if(customerInvoiceTerm.value=="END_NEXT_MONTH"){
    dueDate = moment(invoiceDate).endOf('month').add(1,'month')
  }else{
    dueDate = moment(invoiceDate).add(moment.duration(customerInvoiceTerm.value).asDays(),'days');
  }
  return dueDate;
}



export default {

  /**
   * Validation d'une commande
   * @param  {[type]} salesOrder [description]
   * @return {[type]}            [description]
   */
  validateSalesOrder(salesOrder, validationControl){
    let valid ={
      date : true,
      items : true,
      quantities : true,
      delivery : true,
      billingContact : true,
      shippingContact : true
    }
    if(salesOrder.date == null && validationControl.date){
      valid.date=false;
      Notification.error({message : "Vous devez spécifier une date."})
    }

    const items = salesOrder.lines || salesOrder.items;

    if(items.length==0 && validationControl.lines){
      valid.items = false;
      Notification.error({message : "Vous devez ajouter au moins un produit à la commande."})
    }else{
      if(validationControl.quantities){
        let quantityCheckPassed=true;
        _.forEach(items, i=>{
          if(i.validations!=null && i.validations.length>0){
            quantityCheckPassed=false;
          }
        })
        if(!quantityCheckPassed){
          valid.quantities=false;
        }
      }

    }
    if(validationControl.delivery && salesOrder.deliveryType!=null && salesOrder.deliveryType.choice_custom_info!=null && salesOrder.extraInfo.location==null){
      valid.delivery=false;
      Notification.error({message : "Vous devez sélectionner une succursale pour la livraison."})
    }

    if(salesOrder.customer.type==1){
      let billingContact = _.get(salesOrder, 'billingContact');
      if(validationControl.billingContact && billingContact == null || (billingContact != null &&  billingContact.isActiveInCompany === false)){
        valid.billingContact=false;
        Notification.error({message : "Le contact de facturation n'est plus associé au client. Veuillez en choisir un nouveau."})
      }

      let shippingContact = _.get(salesOrder, 'shippingContact');
      if(validationControl.shippingContact && shippingContact == null || (shippingContact != null && shippingContact.isActiveInCompany === false)){
        valid.shippingContact=false;
        Notification.error({message : "Le contact de livraison n'est plus associé au client. Veuillez en choisir un nouveau."})
      }
    }

    return valid;
  },
  /**
   * Retourne une chaine de caractère avec le nom des taxes séparé par des
   * virgule et débutant par un "+"
   * @param  {[type]} taxesArray [description]
   * @return {[type]}            [description]
   */
  getUsedTaxesNames(taxesArray){
    let names = '';
    if(taxesArray!=null){
      _.forEach(taxesArray, (t, i)=>{
        if(i>0)names+=', ';
        names+=t.name;
      })
      names='+'+names;
    }

    return names;
  },
  /**
   * Retourne une collection de taxes avec le total de chacune
   * des taxes selon les lignes de produits et les taxes associées
   * aux produits.
   * @param  {[type]} lines [description]
   * @return {[type]}       [description]
   */
  calculateTaxesFromProductLines(lines){
    let taxes = [];
    _.forEach(lines, l=>{
      _.forEach(l.taxes, ptd=>{
        let tax = _.find(taxes, t=>{return t.id==ptd.id})
        if(tax==null){
          tax = _.cloneDeep(ptd);
          tax.total = 0.00;
          taxes.push(tax);
        }
        tax.total += l.qty*l.price*ptd.rate;
      })
    })
    _.forEach(taxes, t=>{
      t.total = Math.round(t.total*100)/100;
    })
    return taxes;
  },
  isPositive(so){
    if(so.status.code=='TO_PROCESS' || so.status.code=='TO_PROCESS_PAID' || so.status.code==='"AWAITING_BILLING"'){
      return (!this.isNegative(so) && !this.isIntermediary(so))
    }
    return false;

  },
  isNegative(so){
    if(so.status.code=='TO_PROCESS' || so.status.code=='TO_PROCESS_PAID' || so.status.code==='"AWAITING_BILLING"'){
      //processDate = a la date que la commande doit être passée
      var processDate = moment(so.date);
      //Si la date de la commande est aujourd'hui
      if(moment(processDate).isSame(moment(), 'day')){
        if(so.deliveryType!=null && so.deliveryType.code==="CUSTOMER_DELIVERY_9H"){
          return moment(new Date()).hours()>=9;
        }else if(so.deliveryType!=null && so.deliveryType.code==="CUSTOMER_DELIVERY_16H"){
          return moment(new Date()).hours()>=16;
        }
      }else if(moment(processDate).isBefore(moment(), 'day')){
        //Si la date de la commande est passé
        return true;
      }
    }

    return false;
  },isIntermediary(so){
      if(so.status.code=='TO_PROCESS' || so.status.code=='TO_PROCESS_PAID' || so.status.code==='"AWAITING_BILLING"'){
      //processDate = a la date que la commande doit être passée
      var processDate = moment(so.date);

      //Si la date de la commande est aujourd'hui
      if(moment(processDate).isSame(moment(), 'day')){
        if(so.deliveryType!=null && so.deliveryType.code==="CUSTOMER_DELIVERY_9H"){
          return moment(new Date()).hours()<9;
        }else if(so.deliveryType!=null && so.deliveryType.code==="CUSTOMER_DELIVERY_16H"){
          return moment(new Date()).hours()<16;
        }else {
          return true;
        }
      }
    }

    return false;
  }

}
